import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import ISOCertificate from "../../components/auth/Certificates/ISOCertificate";
import ComplianceCertificate from "../../components/auth/Certificates/ComplianceCertificate";
import AddCertificates from "../../components/Modals/AddCertificatesModal";
import { Pagination, Stack } from "@mui/material";

const Certificates = () => {
  const [activeTab, setActiveTab] = useState("ISO Certificate");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const itemsPerPage = 6;

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleDataChange = (pages, items) => {
    setTotalPages(pages);
    setTotalItems(items);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(1);
    setQuery("");
  };

  const commonProps = {
    query,
    page,
    itemsPerPage,
    onDataChange: handleDataChange,
  };

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "ISO Certificate":
        return <ISOCertificate {...commonProps} />;
      case "Compliance Certificate":
        return <ComplianceCertificate {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* Header Section */}
      <div className="py-12 px-6">
        <div className="flex justify-between flex-col md:flex-row">
          <h1 className="text-primaryColor text-[25px] md:text-3xl font-bold">
            Certificates
          </h1>

          <div className="flex gap-2">
            {/* Search Bar */}
            <div className="searchBar hidden md:flex relative items-center md:mt-0">
              <input
                type="text"
                placeholder="Search..."
                value={query}
                onChange={handleInputChange}
                className="pl-4 pr-10 py-2 border-2 border-primaryColor rounded-lg"
              />
              <span className="absolute w-10 h-10 right-0 rounded-r-md bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] p-2">
                <FaSearch size={20} className="text-white" />
              </span>
            </div>

            {/* Add Button */}
            <div>
              <button
                onClick={() => setShowModal(true)}
                className="hidden md:flex pl-4 pr-4 py-2 h-11 border-2 bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white rounded-lg"
              >
                + Add New
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="px-6">
        <div className="border-b tracking-wide justify-center">
          <div className="flex justify-center">
            {["ISO Certificate", "Compliance Certificate"].map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabChange(tab)}
                className={`px-6 py-3 text-sm font-medium border-b-2 ${
                  activeTab === tab
                    ? "border-primaryColor text-primaryColor bg-purple-50"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="p-4">{renderActiveTabContent()}</div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 my-6">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
            />
          </Stack>
          <div className="text-sm text-gray-600">
            Showing {Math.min((page - 1) * itemsPerPage + 1, totalItems)} to{" "}
            {Math.min(page * itemsPerPage, totalItems)} of {totalItems} results
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <AddCertificates
          onClose={() => setShowModal(false)}
          onSubmit={(certificate) => {
            console.log("Submitted certificate:", certificate);
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default Certificates;
